const open = (popup) => {
	const headerEl = document.querySelector(".dg-driessen-header");
	popup.style.display = "block";
	document.body.classList.add("dg-body-no-scroll");
	if(popup.dataset['popup'] === 'fixed-contract-info-modal' && window.innerWidth >= 1200){
		document.body.classList.add("dg-opened-on-large-display");
	}
	headerEl.style.zIndex = "10";
}

const close = (popup) => {
	const headerEl = document.querySelector(".dg-driessen-header");
	popup.style.display = "none";
	console.log(popup.dataset);
	if(popup.dataset['popup'] === 'fixed-contract-info-modal' && window.innerWidth >= 1200){
		document.body.classList.remove("dg-body-no-scroll");
	}
	if(popup.dataset['popup'] !== 'fixed-contract-info-modal'){
		document.body.classList.remove("dg-body-no-scroll");
	}
	if(popup.dataset['popup'] === 'fixed-contract-info-modal' && window.innerWidth <= 1200 && document.body.classList.contains("dg-opened-on-large-display")){
		document.body.classList.remove("dg-body-no-scroll");
		document.body.classList.remove("dg-opened-on-large-display");
	}
	headerEl.style.zIndex = "";
}

const bindPopup = (openButtonElements, popupElement) => {
	openButtonElements.forEach(button => {
		button.addEventListener("click", () => { open(popupElement); });
	});

	const closeButtons = popupElement.querySelectorAll(`[data-popup-close]`);
	closeButtons.forEach(button => {
		button.addEventListener("click", async () => { close(popupElement);} );
	});

	document.addEventListener("keydown", async (event) => {
		if (event.key === "Escape") {
			await close(popupElement);
		}
	});
}

export const bindGenericPopups = () => {
	const popupButtons = document.querySelectorAll("[data-popup-button]");

	popupButtons.forEach(popupTrigger => {
		const popupElement = document.querySelector(`[data-popup=${popupTrigger.dataset.popupButton}]`);

		if(popupElement)
			bindPopup(popupButtons, popupElement);
	});
}
